const ReplyItem = ({ reply }) => {
  return (
    <>
    <h1 class="reply-item">{reply.content}</h1>
    </>
  );
};

export default ReplyItem;